/**
 * Shadow tokens from the Figma "UI Design System" effect styles.
 * Source of truth: Pangea Galapagos UI Design System — Beta
 * https://www.figma.com/design/Orc6uUodQaoXep59CGaUNw
 */

export interface ShadowDefinition {
  color: string;
  offset: { width: number; height: number };
  radius: number;
  spread: number;
  elevation?: number;
}

export const shadows = {
  shadow200: {
    color: 'rgba(33, 38, 51, 0.04)',
    offset: { width: 0, height: 2 },
    radius: 4,
    spread: 0,
    elevation: 1,
  },
  shadow300: {
    color: 'rgba(33, 38, 51, 0.08)',
    offset: { width: 0, height: 5 },
    radius: 10,
    spread: 0,
    elevation: 4,
  },
  shadow400: {
    color: 'rgba(33, 38, 51, 0.12)',
    offset: { width: 0, height: 8 },
    radius: 16,
    spread: 0,
    elevation: 6,
  },
  shadow500: {
    color: 'rgba(33, 38, 51, 0.16)',
    offset: { width: 0, height: 12 },
    radius: 24,
    spread: 0,
    elevation: 8,
  },
  shadow600: {
    color: 'rgba(33, 38, 51, 0.20)',
    offset: { width: 0, height: 16 },
    radius: 32,
    spread: 0,
    elevation: 10,
  },
  flat: {
    color: '#cccccc',
    offset: { width: 2, height: 4 },
    radius: 0,
    spread: 0,
    elevation: 2,
  },
  flatSelected: {
    color: '#222222',
    offset: { width: 2, height: 4 },
    radius: 0,
    spread: 0,
    elevation: 3,
  },
  flatLg: {
    color: '#212633',
    offset: { width: 8, height: 8 },
    radius: 0,
    spread: 0,
    elevation: 8,
  },
} as const satisfies Record<string, ShadowDefinition>;

export type Shadows = typeof shadows;
